// Main product only. Product cards and quick-add retain their own option flows.
function mainPicker(source) {
  if (source?.closest('product-card, quick-add-dialog, dialog')) return null;
  return document.querySelector('main variant-picker[data-template-product-match="true"]');
}
function needsSize(picker) {
  return !!picker?.querySelector('input[data-option-name="Size"]') && !picker.c13SizeConfirmed;
}
export function c13RequireSize(source) {
  const picker = mainPicker(source);
  if (!needsSize(picker)) return false;
  const input = picker.querySelector('input[data-option-name="Size"]');
  const fieldset = input.closest('fieldset');
  fieldset.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  input.focus({preventScroll:true});
  return true;
}
function syncPurchaseLabel() {
  const picker = mainPicker();
  if (!picker) return;
  const pending = needsSize(picker);
  picker.closest('.shopify-section')?.querySelectorAll('[data-c13-atc-label]').forEach(label => {
    const button = label.closest('button');
    if (!button || button.disabled) return;
    const text = pending ? 'Choose a size' : 'Add to cart';
    if (label.textContent !== text) label.textContent = text;
  });
  const sticky = document.querySelector('sticky-add-to-cart [ref="addToCartButton"]');
  if (sticky) {
    const text = pending ? 'Choose a size' : 'Add to cart';
    if (sticky.getAttribute('aria-label') !== text) sticky.setAttribute('aria-label',text);
  }
}
const main = document.querySelector('main');
if (main) new MutationObserver(syncPurchaseLabel).observe(main,{subtree:true,childList:true});
document.addEventListener('change', () => queueMicrotask(syncPurchaseLabel));
customElements.whenDefined('variant-picker').then(syncPurchaseLabel);
let guide;
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-c13-size-guide]');
  if (!trigger) return;
  event.preventDefault();
  const section = trigger.closest('.shopify-section');
  const row = [...section.querySelectorAll('details')].find(el => el.querySelector('summary')?.textContent.trim() === 'Size Chart');
  const image = row?.querySelector('img');
  const table = row?.querySelector('table');
  if (!image && !table) { row?.setAttribute('open',''); row?.scrollIntoView({block:'center'}); return; }
  guide?.remove();
  guide = document.createElement('dialog');
  guide.className='c13-guide-dialog';
  guide.setAttribute('aria-labelledby','c13-guide-heading');
  const heading = document.createElement('h2');heading.id='c13-guide-heading';heading.textContent='Size guide';
  const close = document.createElement('button');close.type='button';close.className='c13-guide-close';close.textContent='Close';
  const body = document.createElement('div');body.className='c13-guide-content';
  {
    const isStandard=!!section.querySelector('[data-c13-garment="standard"]');
    const isKids=section.querySelector('variant-picker')?.dataset.c13Fit === 'kids';
    // Printify Comfort Colors 1717 catalog, verified 2026-10-08. Inches; laid-flat dimensions.
    const measures = isStandard ? {S:[18,28],M:[20,29],L:[22,30],XL:[24,31],'2XL':[26,32],'3XL':[28,33],'4XL':[30,34]} : isKids ? {XS:[16.14,20.47],S:[16.93,22.05],M:[18.11,23.62],L:[18.90,25.20],XL:[20.08,26.38]} : {S:[18.25,26.62],M:[20.25,28],L:[22,29.37],XL:[24,30.75],'2XL':[26,31.62],'3XL':[27.75,32.5],'4XL':[29.75,33.5]};
    const intro=document.createElement('p');intro.textContent=isStandard?'Standard · Gildan 64000 · Inches':isKids?'Kids · Gildan 5000B · Inches':'Adult · Comfort Colors 1717 · Inches';body.append(intro);
    const table=document.createElement('table');table.className='c13-size-table';
    table.innerHTML='<thead><tr><th scope="col">Size</th><th scope="col">Width</th><th scope="col">Length</th></tr></thead>';
    const tbody=document.createElement('tbody');
    section.querySelectorAll('input[data-option-name="Size"]').forEach(input=>{
      const dims=measures[input.value];if(!dims)return;
      const row=document.createElement('tr');
      const name=document.createElement('th');name.scope='row';name.textContent=input.value;row.append(name);
      dims.forEach(value=>{const cell=document.createElement('td');cell.textContent=value.toFixed(2);row.append(cell);});tbody.append(row);
    });table.append(tbody);body.append(table);
    const tolerance=document.createElement('p');tolerance.textContent=isStandard?'Width is measured across the chest, not around it. Garment measurements may vary slightly.':'Width is measured across the chest, not around it. Measurements may vary by up to '+(isKids?'1 inch.':'1.5 inches.');body.append(tolerance);
  }
  const hint = document.createElement('p');hint.textContent='Compare with a favorite shirt, laid flat. If the fit is not right, request one free size replacement within 30 days of delivery. Same design and garment color; replacement shipping included, no return needed.';
  guide.append(heading,close,body,hint);document.body.append(guide);
  const previousOverflow = document.body.style.overflow;
  guide.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;trigger.focus({preventScroll:true});},{once:true});
  close.addEventListener('click',()=>guide.close());
  document.body.style.overflow='hidden';guide.showModal();
});
// Keep preview links on the same unpublished theme across the adult/kids switch.
document.addEventListener('click',event=>{
  const link=event.target.closest('[data-c13-age-link]');
  if(link?.getAttribute('aria-current')==='page'){event.preventDefault();return;}
  const preview=link?.closest('[data-c13-preview-theme]')?.dataset.c13PreviewTheme || new URL(location.href).searchParams.get('preview_theme_id');
  if(link && preview){const url=new URL(link.href);url.searchParams.set('preview_theme_id',preview);link.href=url.href;}
});
